module.exports = __webpack_public_path__ + "images/eye-closed-00256b.svg";